import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { CONTRACTS__ABSENT } from 'translations/constants';
import { INoShowReasonDetail } from 'types/absence-reason/IAbsenceReason';
import { getReasonName } from 'utils/absence-reason';

interface AbsenceIndicatorProps {
  reason?: INoShowReasonDetail | null;
}

const AbsenceText = styled('span')({
  color: '#FF8C00',
  fontWeight: 600,
  fontSize: '14px',
});

const AbsenceIndicator = (props: AbsenceIndicatorProps) => {
  const { reason } = props;
  const { t, i18n } = useTranslation();

  const label = reason ? `${t(CONTRACTS__ABSENT)}: ${getReasonName(reason, i18n.language)}` : t(CONTRACTS__ABSENT);

  return <AbsenceText>{label}</AbsenceText>;
};

AbsenceIndicator.defaultProps = {
  reason: null,
};

export default AbsenceIndicator;
